// Exchange — 5-tile stats strip. Pure presentation. Receives the
// already-derived ExchangeStatsView from the page so the same hook
// state powers the toolbar and chip rail counts without re-fetching.

import type { ExchangeStatsView } from "./exchange-derive.ts";

interface Props {
  stats: ExchangeStatsView;
  loading: boolean;
}

function fmtAvgEdge(pct: number | null): string {
  if (pct === null) return "—";
  const sign = pct > 0 ? "+" : "";
  return `${sign}${pct.toFixed(1)}`;
}

export function ExchangeStats({ stats, loading }: Props): JSX.Element {
  const tiles = [
    {
      k: "Live signals",
      v: loading ? "—" : String(stats.liveCount),
      unit: `of ${String(stats.scoutedTotal)} scouted`,
      delta: loading ? "" : "Curated public-ready cards",
      deltaCls: "" as const,
    },
    {
      k: "Tier 1 leagues",
      v: loading ? "—" : String(stats.tier1Count),
      unit: "matches",
      delta: "Highest data tier",
      deltaCls: "" as const,
    },
    {
      k: "Avg estimated edge",
      v: fmtAvgEdge(stats.averageEdgePct),
      unit: "%",
      delta: "vs market implied",
      deltaCls: "pos" as const,
    },
    {
      k: "Watched by you",
      v: loading ? "—" : String(stats.watchedCount),
      unit: "",
      delta: stats.watchedCount === 0 ? "Add signals to your watchlist" : "Saved on your account",
      deltaCls: "" as const,
    },
    {
      k: "Closing soon",
      v: loading ? "—" : String(stats.closingSoonCount),
      unit: "in 24h",
      delta: "Observation window",
      deltaCls: "" as const,
    },
  ];
  return (
    <div className="ex-stats">
      {tiles.map((s) => (
        <div className="ex-stat" key={s.k}>
          <div className="k">{s.k}</div>
          <div className="v">
            {s.v}
            {s.unit !== "" ? <span className="unit">{s.unit}</span> : null}
          </div>
          {s.delta !== "" ? <div className={`delta ${s.deltaCls}`}>{s.delta}</div> : null}
        </div>
      ))}
    </div>
  );
}
